module.exports = __webpack_public_path__ + "img/xiaohuoshuan.be5aaabd.jpg";